module.exports = __webpack_public_path__ + "static/phone-bcca6c5e35aff0a5db37289d2e2b538c.png";